import { motion } from "framer-motion";

const items = [
  "Se acordas com uma sensação que não consegues nomear.",
  "Se já não te reconheces nas escolhas que fizeste por todos menos por ti.",
  "Se sabes que algo tem de mudar — mas vais adiando a conversa.",
  "Se tens medo de admitir o que já sabes há muito tempo.",
  "Se procuras clareza, não respostas prontas.",
  "Se estás pronta para dares um passo, só um.",
];

export default function ForYou() {
  return (
    <section
      id="para-ti"
      data-testid="for-you-section"
      className="py-24 md:py-36 px-6 md:px-12 bg-cream-soft"
    >
      <div className="max-w-[1200px] mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.4 }}
          className="grid grid-cols-1 md:grid-cols-12 gap-12 mb-14"
        >
          <div className="md:col-span-3">
            <span className="section-num">02 · Para ti</span>
          </div>
          <div className="md:col-span-9">
            <h2 className="font-display text-4xl md:text-5xl lg:text-6xl text-ink leading-[1.02]">
              Este livro é para ti,
              <br />
              se <span className="brush-underline">reconheces</span>{" "}
              <span className="font-serif-display text-orange normal-case lowercase">algo aqui.</span>
            </h2>
          </div>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {items.map((it, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-50px" }}
              transition={{ duration: 0.3, delay: i * 0.035 }}
              data-testid={`for-you-item-${i}`}
              className="card-soft p-7"
            >
              <span className="section-num mb-4 inline-flex">
                {String(i + 1).padStart(2, "0")}
              </span>
              <p className="text-base md:text-lg text-ink leading-snug">{it}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
